import {Component, DestroyRef, inject} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './core/services/language.service';
import { RouterOutlet } from '@angular/router';
import { PwaInstallService } from './shared/services/pwa-install.service';
import { ThemeService } from './shared/services/theme.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {

    private readonly pwaInstall = inject(PwaInstallService);
    private readonly themeService = inject(ThemeService);
    private readonly swUpdate = inject(SwUpdate);
    private readonly destroyRef = inject(DestroyRef);

    constructor(public translate: TranslateService, private languageService: LanguageService) {
        this.languageService.init();
        this.themeService.init();
        this.listenForUpdates();
    }

    private listenForUpdates(): void {
        if (!this.swUpdate.isEnabled) return;

        const sub = this.swUpdate.versionUpdates.subscribe(event => {
            if (event.type === 'VERSION_READY') {
                document.location.reload();
            }
        });
        this.destroyRef.onDestroy(() => sub.unsubscribe());
    }

}
